export function registerVPortal($) {
  if (!$ || $.fn.vPortal) return;

  var pagination = function (
    el,
    dataType,
    shortUrl,
    blockName,
    params,
    after = function () {},
    paginationOptions = {},
  ) {
    var itemTotal = $(el.parentContainer + el.itemTotal).val();
    var itemPerPage = $(el.parentContainer + el.itemPerPage).val();
    var modulusPage = itemTotal % itemPerPage > 0 ? 1 : 0;

    var totalPages = parseInt(itemTotal / itemPerPage) + modulusPage;

    var searchPage = 1;

    if (totalPages > 1) {
      if (typeof $.fn.twbsPagination !== "function") {
        console.error("❌ twbsPagination plugin chưa nạp (cần CDN cho phân trang)");
        return;
      }
      $(el.parentContainer + el.paginationContainer).twbsPagination({
        startPage: searchPage,
        totalPages: totalPages,
        visiblePages: 5,
        first: "&laquo;",
        prev: "&lsaquo;",
        next: "&rsaquo;",
        last: "&raquo;",
        paginationClass: "pagination",
        nextClass: "next",
        prevClass: "prev",
        lastClass: "last",
        firstClass: "first",
        initiateStartPageClick: false,
        onPageClick: function (event, page) {
          loadNews(
            el,
            page,
            "paging",
            dataType,
            shortUrl,
            blockName,
            params,
            after(),
            paginationOptions,
          );
          return false;
        },
        ...paginationOptions,
      });
    } else {
      $(el.parentContainer + el.paginationContainer).empty();
      $(el.parentContainer + el.paginationContainer).removeData("twbs-pagination");
      $(el.parentContainer + el.paginationContainer).unbind("page");
    }
  };

  var loadNews = function (
    el,
    page,
    type,
    dataType,
    shortUrl,
    blockName,
    params = "",
    after = function () {},
    paginationOptions = {},
  ) {
    var url = shortUrl + "/" + blockName + "." + page + ".html";
    url = url.replaceAll("///", "/");
    url = url.replaceAll("//", "/");
    url = "//" + url;

    if (params.length > 0) {
      url += params;
    }

    after();

    if (blockName && shortUrl && url.indexOf("undefined") < 0) {
      $.ajax({
        url: url,
        dataType: dataType,
        success: function (result) {
          $(el.parentContainer + el.resultContainer).html(result);
          window.dispatchEvent(new Event("resize"));

          if (type == "loadTab") {
            $(el.parentContainer + el.paginationContainer).empty();
            $(el.parentContainer + el.paginationContainer).removeData("twbs-pagination");
            $(el.parentContainer + el.paginationContainer).unbind("page");

            if ($(el.parentContainer + el.itemTotal).val() > 0) {
              pagination(
                el,
                dataType,
                shortUrl,
                blockName,
                params,
                after(),
                paginationOptions,
              );
            }
          }

          after();
        },
      });
    }
  };

  $.fn.vPortal = function (options) {
    var defaults = {
      container: "",
      el: {
        parentContainer: "",
        tabContainer: "",
        resultContainer: "",
        paginationContainer: ".pagination",
        containerSuffix: "",
        viewAll: "",
        itemTotal: "#itemTotal",
        itemPerPage: "#itemPerPage",
        currentSection: "#currentSection",
        shortUri: "#shortUri",
      },
      data: {
        startPage: 1,
        totalPage: 1,
      },
      paginationOptions: {},
      before: function () {},
      after: function () {
        window.dispatchEvent(new Event("resize"));
      },
    };

    var settings = {
      ...defaults,
      ...options,
      el: {
        ...defaults.el,
        ...options.el,
      },
      data: {
        ...defaults.data,
        ...options.data,
      },
    };

    settings.el.parentContainer = settings.container + " ";

    settings.before();

    if (
      $(settings.el.parentContainer + settings.el.paginationContainer).length > 0
    ) {
      var $elPagination = $(
        settings.el.parentContainer + settings.el.paginationContainer,
      );

      var params = $elPagination.attr("data-params");
      if (params == undefined) {
        params = "";
      }

      var dataType = $elPagination.attr("data-type");
      if (dataType == undefined) {
        dataType = "json";
      }

      var blockName = $elPagination.attr("data-block-name");
      if (blockName == undefined) {
        blockName = "";
      }

      var shortUrl = $elPagination.attr("data-shorturl");
      if (shortUrl == undefined) {
        shortUrl = "";
      }

      pagination(
        settings.el,
        dataType,
        shortUrl,
        blockName,
        params,
        settings.after(),
        settings.paginationOptions,
      );
    }

    $("body").on(
      "click",
      settings.el.parentContainer +
        settings.el.tabContainer +
        settings.el.containerSuffix,
      function (e) {
        e.preventDefault();

        if ($(this).attr("href") != "#") {
          window.location.href = $(this).attr("href");
        }

        $(
          settings.el.parentContainer +
            settings.el.tabContainer +
            settings.el.containerSuffix,
        ).removeClass("active");
        var params = $(this).data("params");
        if (params == undefined) {
          params = "";
        }

        var dataType = $(this).data("type");
        if (dataType == undefined) {
          dataType = "json";
        }

        var viewAll = $(this).data("viewall");
        if (viewAll == undefined) {
          viewAll = "#";
        }
        var blockName = $(this).data("block-name");
        var shortUrl = $(this).data("shorturl");

        $(this).addClass("active");

        loadNews(
          settings.el,
          1,
          "loadTab",
          dataType,
          shortUrl,
          blockName,
          params,
          function () {
            $(settings.el.parentContainer + settings.el.viewAll).attr("href", viewAll);
          },
          settings.paginationOptions,
        );

        return false;
      },
    );
  };
}

export function loadTwbsPagination(callback) {
  if (typeof window.jQuery !== "undefined" && typeof window.jQuery.fn.twbsPagination === "function") {
    callback();
    return;
  }
  // libraryMainsite chỉ gán window.$, plugin twbs lại tự gắn vào window.jQuery
  window.jQuery = window.jQuery || window.$;
  var script = document.createElement("script");
  script.src =
    "https://cdnjs.cloudflare.com/ajax/libs/twbs-pagination/1.4.2/jquery.twbsPagination.min.js";
  script.onload = function () {
    callback();
  };
  script.onerror = function () {

    console.error("❌ Không nạp được twbsPagination CDN — giữ phân trang tĩnh, vPortal vẫn init");
    callback();
  };
  document.head.appendChild(script);
}
